import CategoriesContainer from 'features/Categories';
import KioskLog from 'models/KioskLog';
import React from 'react';
import { useParams } from "react-router-dom";
import withRouter from '../../shared/utils/WithRouter';

// display specific category
const CategoryPage = (props) => {
	const { id } = useParams();
	if (
		id === undefined ||
		id === 'search' ||
		Number.isInteger(Number(id))
	) {
		return <CategoriesContainer id={id} />;
	}
	const log = new KioskLog(
		new Error('Category not located.'),
		`id: ${id} - fileLocation: pages/CategoryPage`,
	);
	log.postMessage();
	props.router.navigate('/errorPage', { 
		state: { 
			text: `We don't think the category ID "${id}" exists.` 
		} 
	});
};

export default withRouter(CategoryPage);
